import { render, staticRenderFns } from "./NotificateUsers.vue?vue&type=template&id=184ded80&"
import script from "./NotificateUsers.vue?vue&type=script&lang=js&"
export * from "./NotificateUsers.vue?vue&type=script&lang=js&"
import style0 from "./NotificateUsers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NotificateUsers.vue"
export default component.exports